import ListTransform from '@model/list/ListTransform'
import Locale from '@serv/Locale'

class ListTransformString extends ListTransform {
    constructor(object) {
        super(object)
    }

    get getFilterComponent() {
        return 'DataFilterString'
    }

    get getFilterConfig() {
        if (!this.column?.valueFilterOptions) {
            return
        }

        const valueLabels = this.column.valueFilterOptions.map(option => {
            const text = Locale.getLanguageItemForModelEnum(this.column.label, option)

            return { value: option, label: text }
        })

        return {
            title: Locale.getLanguageItem(this.column.label),
            valueLabels: this.column.sortValueLabels(valueLabels),
            addAll: true
        }
    }

    getQueryParamValueFromKeyStrings(keyStrings) {
        return {
            values: keyStrings
        }
    }
}

export default ListTransformString
